<script>
  import { createEventDispatcher } from 'svelte';
  import Modal from '@components/Modal.svelte';
  import EmojiPicker from '@app-components/EmojiPicker.svelte';

  const dispatch = createEventDispatcher();
  export let mobile = false;
  export let show;
</script>

<style style="text/scss" lang="scss">
  * :global(.modal__container) {
    width: 400px !important;
    height: 410px !important;
  }
  * :global(.modal__content) {
    margin-bottom: 0px !important;
    margin-top: 0px !important;
  }

  * :global(.modal__close) {
    padding: 0px !important;
    margin: 0px !important;
  }

  * :global(.emoji-picker) {
    box-shadow: none !important;
    padding: 5px !important;
    width: 83% !important;
    min-width: 83% !important;
  }
</style>

<div class="svelte-modal">
  <Modal
    mobile={mobile}
    on:close={() => {
      show = false;
      dispatch('close');
    }}
    bind:show={show}
    showCloseButton={true}
    fadeInDuration={200}>
    <div slot="content" class:mobile={mobile}>
      <EmojiPicker
        mobile={mobile}
        on:emoji-selected={(e) => {
          show = false;
          dispatch('emoji-selected', { emoji: e.detail.emoji });
        }} />
    </div>
  </Modal>
</div>
